import { Box, Grid, List, ListItem, makeStyles, Theme, Typography } from '@material-ui/core';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import clsx from 'clsx';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { member as v_member, basic, Values, SNACKBAR_TIME } from '../../../request/values';
import { COLORS } from '../../../shared/Theme';
import ToastStr from '../../../request/toastStr';
import { TitleBarWithButton } from '../../../shared/header/TitleBar';
import { getTranslatedMaterialName, formatToTimezone } from '../../../locales/formatModule';

const useStyles = makeStyles((theme: Theme) => ({
	wrapper: {
		paddingTop: '0',
		paddingLeft: '0',
		paddingRight: '0',
		[theme.breakpoints.up('md')]: {
			paddingTop: '10px',
			paddingLeft: '20px',
			paddingRight: '20px',
		},
	},
	container: {
		padding: 0,
		display: 'grid',
	},
	titleWrapper: {
		width: '100%',
		textAlign: 'center',
	},
	title: {
		...theme.typography.h1,
		color: `${COLORS.BROWNISH_GREY}`,
		textAlign: 'center',
		[theme.breakpoints.up('md')]: {
			...theme.typography.h4,
		},
	},
	materialItem: {
		borderRadius: 12,
		margin: 'auto',
		marginBottom: '1.5vh',

		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		width: '82vw',
		paddingTop: '2.2vh',
		paddingBottom: '2.2vh',
		[theme.breakpoints.up('md')]: {
			width: '60vw',
		},
	},
	itemProcessing: {
		backgroundColor: `${COLORS.LIGHT_GREY}`,
	},
	buttonWrapper: {
		textAlign: 'right',
		marginLeft: 'auto',
		paddingBottom: '1vh',
		paddingRight: '6vw',
		[theme.breakpoints.up('md')]: {
			paddingRight: '0',
		},
	},
	list: {
		width: '95vw',
		height: '70vh',
		overflowY: 'auto',
		...theme.typography.subtitle1,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		[theme.breakpoints.up('md')]: {
			width: '62vw',
			height: '100%',
			paddingTop: theme.spacing(1),
			paddingBottom: theme.spacing(6),
		},
	},
	grid: {
		maxHeight: '80vh',
		overflowY: 'auto',
	},
	paper: {
		padding: theme.spacing(1),
		// margin: 'auto'
	},
	materialImage: {
		// height: 60,
		// width: 60
		textAlign: 'center',
		margin: 'auto',
		'& img': {
			width: '11vw',
			maxWidth: '70px',
		},
	},
	materialList: {
		width: '90%',
		maxWidth: 360,
	},
	materialCompanyName: {
		...theme.typography.body1,
		fontWeight: 'bold',
		fontFamily: 'NanumB',
		color: `${COLORS.WATER_BLUE}`,
	},
	orderSheet: {
		// height : 'calc(100%- 64px)',
		// top: 64
		height: '100vh',
	},
	empty: {
		height: '62vh',
		textAlign: 'center',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& img': {
			width: '35vw',
			height: '35vw',
			[theme.breakpoints.up('md')]: {
				width: '25vw',
				height: '25vw',
			},
			marginBottom: '2.5vh',
			opacity: 0.4,
		},
		'& h1': {
			color: `${COLORS.DOWN}`,
		},
	},
	button: {
		[theme.breakpoints.up('md')]: {
			padding: '1vw',
		},
		padding: '2vw',
		height: 'auto',
		borderRadius: '5px',
		backgroundColor: `${COLORS.WATER_BLUE}`,
		color: `${COLORS.WHITE}`,
		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		...theme.typography.body1,
		fontFamily: 'NanumB',
		//fontWeight: 'bold',
		width: 'auto',
	},
	bottonTitle: {
		color: `${COLORS.BROWNISH_GREY}`,
		...theme.typography.subtitle2,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
	},
	numberWrapper: {
		textAlign: 'right',
		[theme.breakpoints.up('md')]: {
			margin: 'auto',
		},
	},
	numberText: {
		...theme.typography.h1,
		color: `${COLORS.BROWNISH_GREY}`,
		fontWeight: 'normal',
		fontFamily: 'NanumR',
		[theme.breakpoints.up('md')]: {
			...theme.typography.h4,
		},
	},
}));

interface iMaterialList {
	materialCode: number;
	materialName: string;
	materialSubName: string;
	materialImage: string;
	materialPrice: number;
	quantity: number;
	companyName: string;
	companyNum: number;
	materialOrderNum: number;
	orderCompanyNum: number;
	totalPrice: number;
	orderCompanyName: string;
	workingMemberName: string;
}

export interface refHandle {
	refreshCartList: () => void;
	handleOpen: () => void;
}

export interface InputProps {
	oper: any;
}

const MaterialSale: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('student');

	const [material, setMaterial] = useState<iMaterialList[]>([]);
	const { enqueueSnackbar } = useSnackbar();

	const history = useHistory();

	const count = 20;
	let max_count: number = 999;
	const loader = useRef(null);
	const [page, setPage] = useState(-count);

	const { member } = props;

	const moveMaterialSheet = (index: number) => {
		if (index >= 0) {
			history.push({
				pathname: '/MaterialSaleSheet/' + material[index].materialOrderNum,
				state: {
					// location state
					sale: material[index],
				},
			});
		}
	};

	const moveMaterialOrder = () => {
		history.push({
			pathname: '/MaterialOrderList',
		});
	};

	const handleObserver = useCallback((entries: any) => {
		const target = entries[0];
		if (target.isIntersecting) {
			setPage((prevState) => {
				if (prevState + count > max_count) {
					return prevState;
				}
				return prevState + count;
			});
		}
	}, []);

	const handleProcessing = () => {
		return;
	};

	async function getMaxMaterialCount(): Promise<number> {
		let url = new URL(basic.server + v_member.member + v_member.material_count);
		const response = await axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		});
		const data = await response.data;
		const count: number = data.count.count;
		return count;
	}

	const getMaterialSaleAppList = (position: number, count: number) => {
		let url = new URL(basic.server + v_member.member + v_member.material_sale_app_list);
		let params = {
			classCode: member.classCode,
			companyNum: member.companyNum,
			position: position.toString(),
			count: count.toString(),
			email: member.id,
			classVersion: member.classVersion,
		};
		url.search = new URLSearchParams(params).toString();

		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => res.data)
			.then((data: any) => {
				console.log(data.materials);
				console.log(material.length);
				if (data.code === Values.SUCCESS_CODE) {
					if (material.length === 0 && data.materials.length === 0) {
						//enqueueSnackbar(ToastStr.MATERIAL_ORDER_LIST_EMPTY_STR, { variant: "success", autoHideDuration: SNACKBAR_TIME, translate: "no" })
					} else if (data.materials === null) {
						enqueueSnackbar(ToastStr.MATERIAL_ORDER_LIST_EMPTY_STR, {
							variant: 'warning',
							autoHideDuration: SNACKBAR_TIME,
						});
					} else {
						if (material.length === 0) {
							setMaterial(data.materials);
						} else {
							setMaterial((prevState) => prevState.concat(data.materials));
						}
					}
				} else if (data.code === Values.FAIL_CODE) {
					enqueueSnackbar(ToastStr.MATERIAL_ORDER_LIST_FAIL_STR, {
						variant: 'warning',
						autoHideDuration: SNACKBAR_TIME,
					});
				} else if (data.code === Values.EXCEPTION_CODE) {
					enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
						variant: 'error',
						autoHideDuration: SNACKBAR_TIME,
					});
				} else {
					enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
						variant: 'error',
						autoHideDuration: SNACKBAR_TIME,
					});
				}
			});
	};

	useEffect(() => {
		const option = {
			root: null,
			rootMargin: '20px',
			threshold: 0,
		};
		const observer = new IntersectionObserver(handleObserver, option);
		if (loader.current) observer.observe(loader.current!);
	}, [handleObserver]);

	useEffect(() => {
		if (page >= 0) {
			console.log(page);
			getMaterialSaleAppList(page, count);
			const tick = setInterval(() => {
				getMaterialSaleAppList(page, count);
			}, 1000 * 5);
			return () => clearTimeout(tick);
		}
	}, [page]);

	return (
		<div className="contentSmallPdTop" data-testid="dist-material-sale-dashboard">
			<div className={classes.wrapper}>
				<TitleBarWithButton
					history={history}
					title={t('MaterialSale.pageTitle')}
					titleIcon="order"
					buttonCheck={true}
					buttonText={t('MaterialSale.receiptButton')}
					buttonOnClick={moveMaterialOrder}
				/>

				<Box display="grid" justifyContent="center" alignItems="center">
					<List className={classes.list}>
						{material.length != 0 ? (
							material.map((item: any, index) => {
								return (
									<ListItem className={item.workingMemberName != null ? clsx(classes.materialItem, classes.itemProcessing) : classes.materialItem} alignItems="center">
										<MaterialItem
											index={index}
											{...item}
											handleClick={(e: any) => {
												item.workingMemberName != null ? handleProcessing() : moveMaterialSheet(index);
											}}
										/>
									</ListItem>
								);
							})
						) : (
							<div className={classes.empty}>
								<div>
									<img src="/images/title/order.webp" />
									<Typography variant="h1">{t('MaterialSale.empty')}</Typography>
								</div>
							</div>
						)}
						<div ref={loader} />
					</List>
				</Box>
			</div>
		</div>
	);
};

const MaterialItem: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('student');
	const { t: tObject } = useTranslation('object');
	const materialName = getTranslatedMaterialName(tObject, props.materialCode.toString(), props.materialName);
	const formattedTimezone = formatToTimezone(props.materialOrderDate);
	const formattedDate = formattedTimezone ? formattedTimezone[0] : '';
	const formattedTime = formattedTimezone ? formattedTimezone[1] : '';
	return (
		// new version
		<Grid container justify={'center'} alignContent="center" onClick={props.handleClick} data-testid={`dist-material-sale-item-${props.index}`}>
			<Grid xs={2} className={classes.materialImage}>
				<img src={basic.server + '/displayImage?fileName=' + props.materialImage} />
			</Grid>
			<Grid xs={8} style={{ margin: 'auto', paddingLeft: '1vw' }}>
				<Grid container direction="column">
					<Grid id="materialName">
						<Typography display="inline" className={classes.bottonTitle}>
							{materialName}
						</Typography>
						<Typography display="inline" variant="h3" className={classes.bottonTitle}>
							{props.materialCount > 1 ? `${t('MaterialSale.etc')}` : ` `}
						</Typography>
						{/* <Typography display='inline' variant='h3' style={{ color: `${COLORS.WATER_BLUE}`, fontWeight: 'bold' }}>{props.materialCount > 1 ? props.materialCount - 1 : ``}</Typography> */}
						<Typography display="inline" variant="h3" className={classes.bottonTitle}>
							{props.materialCount > 1 ? `${t('MaterialSale.manyOrders')}` : ``}
						</Typography>
					</Grid>
					<Grid id="orderStatus">
						<Typography variant="h1" className={classes.materialCompanyName}>
							{props.workingMemberName != null ? `${props.companyName} / ${props.workingMemberName}` : props.companyName}
						</Typography>
					</Grid>
				</Grid>
			</Grid>
			<Grid xs={2} className={classes.numberWrapper}>
				<Typography className={classes.numberText}>{formattedDate}</Typography>
				<Typography className={classes.numberText}>{formattedTime}</Typography>
			</Grid>
		</Grid>
	);
};
export default MaterialSale;
